import { render, staticRenderFns } from "./BoardForm.vue?vue&type=template&id=9768245a&scoped=true"
import script from "./BoardForm.vue?vue&type=script&lang=js"
export * from "./BoardForm.vue?vue&type=script&lang=js"
import style0 from "./BoardForm.vue?vue&type=style&index=0&id=9768245a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9768245a",
  null
  
)

export default component.exports